import { Box, Typography, styled } from '@mui/material'

export const StyledCardBorder = styled(Box)(({ theme }) => ({
  border: theme.borders.grayLight,
  display: 'inline-block',
  width: '100%',
  height: 'auto',
}))

export const StyledSchoolHeader = styled(Box)(({ theme }) => ({
  textAlign: 'center',
}))

export const StyledMainBox = styled(Box)({
  display: 'flex',
  marginTop: '30px',
  gap: '10px',
  alignItems: 'flex-end',
  marginBottom: '20px',
})

export const StyledSearch = styled(Box)({
  border: '1px solid #22222233 ',
  padding: '7px',
  maxHeight: '55px',
  borderRadius: '10px',
  width: '400px',
})
export const StyledSearchLabel = styled(Typography)({
  fontSize: '14px',
  fontWeight: 'bold',
  margin: '0px 0px 3px 10px',
  color: '#888888',
})
